<template>
  <FeedbackStep :title="title" :number="number">
    <template v-slot:content>
      <div class="feedback-form form">
        <div
          class="form__input-wrapper form__input-wrapper--textarea"
          :class="{ error: $v.form.answer_q8.$anyError }"
        >
          <label for="is-description-import" class="form__label uk-hidden"
            >Co jest dla Ciebie ważne?
          </label>
          <textarea
            class="form-input"
            name="is-description-import"
            id="is-description-import"
            @input="event => delayTouchCounterComposition(
              $v.form,
              'answer_q8',
              event.target.value
            )"
            cols="30"
          />
          <span class="form__error-message form__error-message--no-label">
            <template v-if="!$v.form.answer_q8.minLength">
              {{ validationMessage.minLength }}</template
            >
            <template v-if="!$v.form.answer_q8.required">
              {{ validationMessage.required }}</template
            >
          </span>
        </div>
      </div>
    </template>
  </FeedbackStep>
</template>
<script>
import { minLength, required } from 'vuelidate/lib/validators';
import stepValidation from '../../mixins/stepValidation';
import FeedbackStep from '../global/FeedbackStep.vue';

export default {
  name: 'Question8',
  components: { FeedbackStep },
  mixins: [stepValidation],
  data: () => ({
    title: 'Czy jest coś, co moglibyśmy zrobić lepiej?',
    number: 8,
    form: { answer_q8: '' },
  }),
  validations() {
    return {
      form: {
        answer_q8: {
          required,
          minLength: minLength(3),
        },
      },
    };
  },
};
</script>

<style scoped lang="scss">
.disabled {
  textarea {
    background-color: rgb(235, 235, 235);
    border-color: transparent;
    pointer-events: none;
  }
}
</style>
